// extracted by css-extract-rspack-plugin
export default {"addButtonChirp":"addButtonChirp-qOoB3Y","chirpAppointmentInfo":"chirpAppointmentInfo-AwSSHW","chirpAddedToText":"chirpAddedToText-ADMPve","chirpLink":"chirpLink-qtJerP"};